// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from 'firebase/firestore/lite';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBUreiB8sT0ReKCQHBzUAsbH6fc3B8juG0",
  authDomain: "babylog-da8cb.firebaseapp.com",
  projectId: "babylog-da8cb",
  storageBucket: "babylog-da8cb.appspot.com",
  messagingSenderId: "891591425317",
  appId: "1:891591425317:web:fe152ae4ccdaf0ebceaecc"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

export default db